import Onboarding from '../../imgs/Onboarding/coverImg-Amp.png';
import siCoverImg from '../../imgs/SI/coverImg2.jpg';
import facilityMCoverImg from '../../imgs/FacilityManage/coverImg3.jpg';
//import spotifyCoverImg from '../../imgs/Spotify/cover.png';
// import flightAwareCoverImg from '../../imgs/FlightAware/cover.png';
//import colorBlindCoverImg from '../../imgs/ColorBlind/cover.png';
import worstDriversCoverImg from '../../imgs/WorstDrivers/cover.png';
// import photoAlbumCoverImg from '../../imgs/PhotoAlbum/cover.png';
// import ampCoverImg from '../../imgs/Amp/cover.png';
import cooleafCoverImg from '../../imgs/Cooleaf/coverImg-Cooleaf.png';
import upZoneCoverImg from '../../imgs/UpZone/coverImg-UpZone.png';
import hashingCoverImg from '../../imgs/Hashing/coverImg-Taichi.png';
import assurantCoverImg from '../../imgs/Assurant/coverImg-Assurant.png';

let numOfConfidential = 0;

export const PROJECTS = [
  // {
  //   title: 'Scaled Inference',
  //   name: 'Amp.ai Redesign and MVP',
  //   summary:
  //     'Redesign the existing product based on the business objective and strategic direction. After the market research early this year, we work towards an MVP that incorporates customer requirements and delivers valuable insights.',
  //   date: 'April 2019 - June 2019',
  //   preImg: ampCoverImg,
  //   types: ['Research · ', 'Analysis · ', 'Design'],
  //   isConfidential: true
  // },
  {
    title: 'Cooleaf',
    name: 'Enhancing Engagement and Accessibility on Cooleaf',
    summary:
      'Led the research and design of multimedia inclusion and proposed accessibility guidelines for the platform.',
    date: 'Aug - Dec 2021',
    preImg: cooleafCoverImg,
    types: ['Design · ', 'Research · ', 'Project Management']
  },
  {
    title: 'Hashing Group',
    name: 'Crypto Dashboard Development',
    summary:
      'Led the design and development of the crypto dashboard Taichi from scratch, emphasizing intuitive data visualization and performance optimization.',
    date: 'Oct 2022 - Jan 2024',
    preImg: hashingCoverImg,
    types: ['Prototype · ', 'Interaction · ', 'Visual Design']
    // isConfidential: true
  },
  {
    title: 'Assurant',
    name: 'Consistency with UX Playbook',
    summary:
      "Developed the comprehensive Assurant's UX playbook. Audited and updated the Assurant design system.",
    date: 'May 2022 - August 2022',
    preImg: assurantCoverImg,
    types: ['Design · ', 'Writing · ', 'Research']
    // isConfidential: true
  },
  {
    title: 'Scaled Inference',
    name: 'Amp.ai Onboarding and User Retention',
    summary:
      'Took initiative to design the effective onboarding experience with designers and engineers. Oversaw the process from ideation to production.',
    date: 'July 2018 - August 2018',
    preImg: Onboarding,
    types: ['Design · ', 'Research · ', 'Analysis']
  },
  {
    title: 'UpZone',
    name: 'UpZone: Creative Eco-Design Game',
    summary:
      'Researched, ideated, and created the game prototype to address the barriers that parents face when upcycling and further support their current practices and goals.',
    date: 'Aug - Dec 2021',
    preImg: upZoneCoverImg,
    types: ['Prototype · ', 'Research · ', 'Visual Design']
  }

  // {
  //   title: 'Scaled Inference',
  //   name: 'SI Website Redesign',
  //   summary:
  //     'Revamped the company’s text-heavy website in collaboration with engineering and market teams.',
  //   date: 'Nov 2017 - Feb 2018',
  //   preImg: siCoverImg,
  //   types: ['Design · ', 'Research']
  // },
  //   {
  //     title: 'Lutron',
  //     name: 'Facility Management Interface on Mobile Devices',
  //     summary: `Designed a mobile app corresponding to
  //  client’s existing software. The application allows facility managers to
  // control and monitor buildings through mobile devices.`,
  //     date: 'August 2016 - Dec 2016',
  //     preImg: facilityMCoverImg,
  //     types: ['Design · ', 'Research · ', 'Analysis']
  //   }
  // {
  //   title: 'Side Project',
  //   name: 'Reimagine Spotify Radio Experience',
  //   summary: `By redesigning the user experience of the radio feature on Spotify, I created a web app that allows users to enjoy endless music based on their preference.`,
  //   date: 'September 2017 - October 2017',
  //   preImg: spotifyCoverImg,
  //   types: ['Research · ', 'Design']
  // },
  //   {
  //     title: 'Class Project',
  //     name: 'Web Extension for the Colorblind',
  //     summary: `This project designed to assist color blind people on viewing and
  // interacting with modern web applications.`,
  //     date: 'August 2015 - Dec 2015',
  //     preImg: colorBlindCoverImg,
  //     types: ['Research · ', 'Analysis · ', 'Design']
  //   }
  //   {
  //     title: 'Side Project',
  //     name: 'FlightAware Redesign Concept',
  //     summary: `This unsolicited redesign aims to simplify the app and focus on th
  // e most critical feature.`,
  //     date: 'July 2017 - August 2017',
  //     preImg: flightAwareCoverImg,
  //     types: [
  //       'Research · ',
  //       'Design',
  //     ],
  //   },
  //   {
  //     title: 'Class Project',
  //     name: 'Digital Photo Album for Nursing Home Residents',
  //     summary: `Families mean much to nursing home residents. The project aims to create a
  // simple and intuitive technological solution that will allow residents’ families
  // to share photos and be able to capture residents’ reaction to each photo.`,
  //     date: 'Sept 2015 - Dec 2015',
  //     preImg: photoAlbumCoverImg,
  //     types: ['Research · ', 'Design']
  //   },
  //   {
  //     title: 'Class Project',
  //     name: 'Which State Has the Worst Drivers',
  //     summary: `This project draw people’s attention to the issue of road crashes
  // and through data visualization. We also provided possible reasons that led to the
  // fact that some states have higher accident fatal rates.`,
  //     date: 'March 2016 - May 2016',
  //     preImg: worstDriversCoverImg,
  //     types: ['Analysis · ', 'Design']
  //   }
].map((d, i) => {
  const temp = d;
  if (d.isConfidential) {
    numOfConfidential += 1;
    temp.href = 'mailto:itsritzw@gmail.com';
  } else {
    // eslint-disable-next-line no-mixed-operators
    temp.href = `./cases/case${i - numOfConfidential}`;
  }
  return temp;
});

export const MORE_PROJECTS = [
  {
    type: 'Web Design',
    name: 'Scaled Inference Website Redesign',
    summary:
      'Revamped the company’s text-heavy website in collaboration with engineering and market teams.',
    date: 'Nov 2017 - Feb 2018',
    preImg: siCoverImg,
    types: ['Design · ', 'Research']
  },
  {
    type: 'Mobile App',
    name: "Lutron's Facility Management Interface on Mobile Devices",
    summary: `Designed a mobile app corresponding to
       client’s existing software. The application allows facility managers to
      control and monitor buildings through mobile devices.`,
    date: 'August 2016 - Dec 2016',
    preImg: facilityMCoverImg,
    types: ['Design · ', 'Research · ', 'Analysis']
  },
  // {
  //   type: 'Side Project',
  //   name: 'Reimagine Spotify Radio Experience',
  //   summary: `By redesigning the user experience of the radio feature on Spotify, I created a web app that allows users to enjoy endless music based on their preference.`,
  //   date: 'September 2017 - October 2017',
  //   preImg: spotifyCoverImg,
  //   tags: ['Design · ', 'Research']
  // },
  //   {
  //     type: 'Class Project',
  //     name: 'Digital Photo Album for Nursing Home Residents',
  //     summary: `Families mean much to nursing home residents. The project aims to create a
  // simple and intuitive technological solution that will allow residents’ families
  // to share photos and be able to capture residents’ reaction to each photo.`,
  //     date: 'Sept 2015 - Dec 2015',
  //     preImg: photoAlbumCoverImg,
  //     tags: ['Research · ', 'Design']
  //   },
  {
    type: 'Data Visualization',
    name: 'Which State Has the Worst Drivers',
    summary: `This project draw people’s attention to the issue of road crashes
and through data visualization. We also provided possible reasons that led to the
fact that some states have higher accident fatal rates.`,
    date: 'March 2016 - May 2016',
    preImg: worstDriversCoverImg,
    tags: ['Design · ', 'Coding']
  }
  //   {
  //     type: 'Class Project',
  //     name: 'Web Extension for the Colorblind',
  //     summary: `This project designed to assist color blind people on viewing and
  // interacting with modern web applications.`,
  //     date: 'August 2015 - Dec 2015',
  //     preImg: colorBlindCoverImg,
  //     types: ['Design · ', 'Research · ', 'Analysis']
  //   }
].map((d, i) => {
  const temp = d;
  // eslint-disable-next-line no-mixed-operators
  temp.href = `./cases/case${i + PROJECTS.length - numOfConfidential}`;
  return temp;
});

export const NUM_OF_CONFIDENTIAL = numOfConfidential;



// WEBPACK FOOTER //
// ./src/Modules/Home/data.js